import type { DoctorSlotsByDate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/types'

type RawSlot = {
  time?: string
  time_start?: string
  free?: boolean
  duration?: number
}

/**
 * Слоты `slots_bulk` → карта для календаря: только свободные, с `doctor_id`.
 */
export default function mapDoctorSlots(
  slots: Record<string, RawSlot[]> | undefined,
  doctorId: number,
): DoctorSlotsByDate {
  if (!slots) {
    return {}
  }

  return Object.fromEntries(
    Object.entries(slots).map(([date, daySlots]) => [
      date,
      daySlots
        .filter(slot => slot.free !== false)
        .map(slot => ({
          time: slot.time || slot.time_start || '',
          duration: slot.duration || 0,
          doctor_id: doctorId,
        }))
        .filter(slot => slot.time),
    ]),
  )
}
